import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { LOGO_URL } from "../../helpers/constants";


export default function GameLoader({ text, isLive }: { text: string; isLive: boolean }) {
  const { t } = useTranslation();
  return (
    <div
      className={`w-full h-[500px] lg:h-[300px] flex flex-col items-center justify-center ${
        !isLive
          ? "bg-[var(--bg-canvas)] text-white"
          : "bg-[var(--bg-canvas)] text-[#0b131c]"
      }`}
    >
      {/* Glass panel: translucent, blurred, subtly bordered — makes the mark
          stand out against the flat dark background instead of floating on it. */}
      <div
        className="flex items-center justify-center rounded-3xl"
        style={{
          width: 128,
          height: 128,
          background: "rgba(255, 255, 255, 0.06)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
        }}
      >
        {/* Bounce, ease-in/ease-out */}
        <motion.div
          animate={{ y: [0, -14, 0], scale: [1, 1.06, 1] }}
          transition={{
            repeat: Infinity,
            duration: 1.2,
            ease: "easeInOut",
          }}
          className="w-16 h-16 flex items-center justify-center"
        >
          <img
            src={LOGO_URL}
            alt={t("games_loader_alt", "Loading")}
            className="w-full h-full object-contain"
            style={{ filter: "drop-shadow(0 4px 16px var(--bet-header-accent))" }}
            // This mounts constantly (every route-transition fallback + every
            // fixture-list loading state) — index.html preloads the same
            // LOGO_URL, but these hints help on the rare case the browser
            // hasn't serviced that preload yet by the time this first mounts.
            loading="eager"
            // @ts-ignore — lowercase to match the DOM attribute; this React
            // version doesn't recognize the camelCase `fetchPriority` prop
            fetchpriority="high"
          />
        </motion.div>
      </div>
    </div>
  );
}